import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { useParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

const EditManager = () => {
  const [manager, setManager] = useState({
    id: '',
    name: '',
    email: '',
    phone: '',
    pic: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { id } = useParams(); // Manager ID from URL

  // ✅ Fetch manager data on component mount
  useEffect(() => {
    const fetchManager = async () => {
      try {
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/managers/${id}`);
        if (!response.ok) {
          throw new Error('Manager data fetch failed');
        }
        const result = await response.json();
        setManager(result || {});
        console.log(result);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchManager();
  }, [id]);

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === 'pic' && files && files.length > 0) {
      setManager((prev) => ({
        ...prev,
        pic: files[0], // Store file object
      }));
    } else {
      setManager((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // ✅ Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setSuccessMessage(null);

    const formPayload = new FormData();
    formPayload.append('name', manager.name || '');
    formPayload.append('email', manager.email || '');
    formPayload.append('phone', manager.phone || '');
    if (manager.pic && typeof manager.pic !== 'string') {
      formPayload.append('pic', manager.pic);
    }
     console.log('Submitting manager update with the following data:');
  console.log('Name:', manager.name);
  console.log('Email:', manager.email);
  console.log('Phone:', manager.phone);
  console.log('Pic:', manager.pic); 

    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/manager_upd/${id}`, {
        method: 'POST',
        body: formPayload,
      });

      if (!response.ok) {
        throw new Error('Failed to update manager');
      }

      setSuccessMessage('Manager updated successfully!');
      setError(null);

      // Refetch updated data
      setTimeout(() => {
        window.location.reload(); // Reload page to get updated data
      }, 1500);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  // ✅ Loading spinner
  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="container mt-5">
        {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && <div className="alert alert-success">{successMessage}</div>}

        <div className="card shadow">
          <div className="card-header">
            <h2>Edit Manager</h2>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="name" className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    value={manager.name}
                    onChange={handleChange}
                    placeholder="Enter Manager Name"
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={manager.email}
                    onChange={handleChange}
                    placeholder="Enter Manager Email"
                    required
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="phone" className="form-label">Phone</label>
                  <input
                    type="tel"
                    className="form-control"
                    id="phone"
                    name="phone"
                    value={manager.phone}
                    onChange={handleChange}
                    placeholder="Enter Manager Phone Number"
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Upload Picture</label>
                  <input
                    type="file"
                    className="form-control"
                    name="pic"
                    accept="image/*"
                    onChange={handleChange}
                  />
                  {/* ✅ Show preview if pic is a string URL */}
                  {manager.pic && typeof manager.pic === 'string' && (
                    <img
                      src={`https://apiaksharaconnect.aksharafinalytics.in/${manager.pic}`}
                      alt="Manager"
                      className="img-thumbnail mt-2"
                      width="75"
                    />
                  )}
                </div>
              </div>

              <center>
                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                  {isSubmitting ? 'Updating...' : 'Update'}
                </button>
              </center>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditManager;
